"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProviderLogoObjects = exports.getProviderImageUrl = void 0;
const types_1 = require("@kyruus/types");
const assets_1 = require("./constants/assets");
const provider_1 = require("./provider");
/**
 * Returns the url for the providers image or an appropriate default avatar.
 * @param {object} provider An object containing provider data.
 * @return {string} The appropriate url for the provider image.
 */
function getProviderImageUrl(provider) {
    let providerImageURL = provider.image_url;
    if (!providerImageURL) {
        if (provider.gender === 'Female') {
            providerImageURL = assets_1.FEMALE_PROVIDER_AVATAR_URL;
        }
        else if (provider.gender === 'Male') {
            providerImageURL = assets_1.MALE_PROVIDER_AVATAR_URL;
        }
        else {
            providerImageURL = assets_1.NEUTRAL_PROVIDER_AVATAR_URL;
        }
    }
    return providerImageURL;
}
exports.getProviderImageUrl = getProviderImageUrl;
/**
 * Based on the provider and customer config, returns logos that are applicable to provider
 * @param {object} provider An object containing provider data.
 * @param {object[]} logoConfigs An array of logo config objects for the customer.
 * @param {object[]} facets An array of facet data from the customer config.
 * @return {object[]} An array of objects representing the logos a provider can display
 */
function getProviderLogoObjects(provider, logoConfigs = [], facets, logoSection) {
    const providerLogos = [];
    for (const logoConfig of logoConfigs) {
        let showLogo;
        if (logoSection === types_1.PMCLogoSections.SEARCH) {
            showLogo = logoConfig.show_in_search_results;
        }
        else if (logoSection === types_1.PMCLogoSections.PROFILE) {
            showLogo = logoConfig.show_in_profile;
        }
        if (showLogo) {
            for (const fieldValue of (0, provider_1.getSummaryFieldValues)(provider, facets, logoConfig)) {
                const logo = logoValue(logoConfig, fieldValue);
                if (logo) {
                    providerLogos.push({
                        logo_name: fieldValue.primary,
                        logo_url: logo
                    });
                }
            }
        }
    }
    return providerLogos;
}
exports.getProviderLogoObjects = getProviderLogoObjects;
/**
 * Iterates through the logos of a config to see if they match the passed in field value.
 * @param {object} logoConfig A logo config object from the customer.
 * @param {object} fieldValue A fieldValue representing a partial summary of a provider.
 * @return {string || null} The corresponding url string if a match, otherwise null.
 */
function logoValue(logoConfig, fieldValue) {
    if (logoConfig.logo_map && logoConfig.logo_map.length) {
        for (const logo of logoConfig.logo_map) {
            if (logo.value === fieldValue.primary) {
                return logo.img_url;
            }
        }
    }
    return null;
}
//# sourceMappingURL=images.js.map